import { StyledLink } from "./styles"
import { Box } from "@mui/material"
import React, { useCallback } from "react"
import { LinkProps } from "./types"
import { generatePath, useHistory } from "react-router-dom"
import { useTheme } from "@mui/material/styles"
import { TypographyProps } from "@mui/material/Typography/Typography"

const Link: React.FC<LinkProps & TypographyProps> = (props) => {
  const { text, path, variant } = props
  const history = useHistory()
  const theme = useTheme()

  const handleClick = useCallback(() => {
    if (path.includes("http") || path.includes("mailto")) {
      window.open(path, '_blank').focus();
    } else {
      history.push(generatePath(path))
    }
  }, [history, path])

  return (
    <Box>
      <StyledLink variant={variant} theme={theme} onClick={handleClick}  {...props}>
        {text}
      </StyledLink>
    </Box>
  )
}

export default Link
